// extracted by mini-css-extract-plugin
export default {"tag":"l9jWXEYurirNDXt3aEf8","attention":"btMe539N5W4CfJ68YYIz","inProgress":"i08haQTeqHVDaLyydQCx","approved":"Tbsz85PnDkZsQ3ur5A9z","neutral":"V3Yjf73TNYbnIdJRvINW"};